/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {GLOBAL_CONFIG as ɵb,GlobalConfig as ɵa} from './lib/mat-progress-buttons.injection-token';